module.exports = __webpack_public_path__ + "assets/img/404.6b8ae1d0.gif";